import type { ViewConfigMeta, ViewConfigSheet, ViewConfigWithMetric } from '@salescore/core'
import { arrayMoveImmutable } from 'array-move'

import { bindDispatcher, type StateDispatcher, type StateTransformer } from '../binder'
import { clearCustomSearchQuery } from './searchQuery'

type Entity = ViewConfigWithMetric

const setMeta = ({ config, newMeta }: { config: ViewConfigSheet; newMeta: ViewConfigMeta }): Entity => ({
  ...config,
  meta: {
    ...config.meta,
    ...newMeta,
  },
})

// eslint-disable-next-line sonarjs/todo-tag
// TODO: 最終的には同じatomからViewConfigを操作しているのにsetとgetで違う経路になって謎な構成になっている
const moveField =
  ({
    viewConfig,
    oldFieldIndex,
    newFieldIndex,
  }: {
    viewConfig: ViewConfigWithMetric
    oldFieldIndex: number
    newFieldIndex: number
  }): StateTransformer<Entity> =>
  (previous: ViewConfigWithMetric) => {
    if (viewConfig.type !== 'sheet' || viewConfig.fields === undefined || oldFieldIndex === newFieldIndex) {
      return previous
    }

    const { fields } = viewConfig

    // array-moveは負の数も扱えるので混乱をさけるためガードする
    if (oldFieldIndex < 0 || oldFieldIndex >= fields.length || newFieldIndex < 0 || newFieldIndex >= fields.length) {
      return previous
    }

    return {
      ...viewConfig,
      fields: arrayMoveImmutable(fields, oldFieldIndex, newFieldIndex),
    }
  }

export const bindViewConfigActions = (dispatcher: StateDispatcher<Entity>) => {
  const bind = bindDispatcher(dispatcher)
  return {
    setMeta: bind(setMeta),
    moveField: bind(moveField),
    clearCustomSearchQuery: bind(clearCustomSearchQuery),
  }
}
